<template>
    <div
        class="flex h-screen flex-col items-center justify-center overflow-hidden px-5"
    >
        <div class="flex flex-col items-center text-center">
            <div
                class="mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-yellow-100"
            >
                <svg
                    class="h-10 w-10 text-yellow-500"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    stroke-width="2"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                    />
                </svg>
            </div>

            <h1
                class="mb-3 text-2xl font-semibold text-gray-800"
            >
                Two-Factor Authentication Required
            </h1>

            <p class="mb-2 max-w-md text-gray-500">
                Your team owner requires all members to have Two-Factor
                Authentication (2FA) enabled before accessing the app.
            </p>

            <p class="mb-8 max-w-md text-sm text-gray-400">
                Enable 2FA in your profile settings to continue.
            </p>

            <div class="flex flex-col items-center gap-3 sm:flex-row">
                <AtomicButton
                    size="md"
                    color="yellow"
                    @click="goToProfileSettings"
                >
                    Enable Two-Factor Authentication
                </AtomicButton>
            </div>

            <button
                class="mt-4 text-sm text-gray-400 underline hover:text-gray-600"
                @click="logout"
            >
                Log out
            </button>
        </div>
    </div>
</template>

<script lang="ts" setup>
import BlankLayout from '../../Layouts/Blank.vue';
import AtomicButton from '@atomic/Buttons/AtomicButton.vue';
import { router } from '@inertiajs/vue3';
import { route } from 'ziggy-js';

defineOptions({ layout: BlankLayout });

const goToProfileSettings = () => {
    router.visit(route('settings.profile-settings.index'));
};

const logout = () => {
    router.post(route('logout'));
};
</script>
